"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionSchemaValidator = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const headerSchema = zod_1.z.array(zod_1.z.object({
    name: zod_1.z.string().min(1),
    value: zod_1.z.string().min(1),
}));
const authSchema = zod_1.z.object({
    username: zod_1.z.string().min(1),
    password: zod_1.z.string().min(1),
});
const actionAdvancedOptions = zod_1.z.object({
    headers: headerSchema,
    auth: authSchema.optional(),
});
exports.actionSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    name: zod_1.z.string().min(1).optional(),
    url: zod_1.z.string().url(),
    success_message: zod_1.z.string().min(1),
    advanced_opts: actionAdvancedOptions
        .default({
        headers: [
            {
                name: 'Content-Type',
                value: 'application/json',
            },
        ],
    })
        .optional(),
}));
